// extracted by mini-css-extract-plugin
module.exports = {"scoreInfluenceAwareContent":"style-module__scoreInfluenceAwareContent___2mMIp","detractor":"style-module__detractor___2Bw7X","promoter":"style-module__promoter___1bKVt"};